import React from 'react';

const Telegram = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="45" height="38" fill="none" viewBox="0 0 45 38">
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M1.418 17.83L39.97 1.006a3.057 3.057 0 014.243 3.278l-4.806 30.49a3.439 3.439 0 01-5.367 2.283L20.509 27.6a1.91 1.91 0 01-.269-2.905L33.33 11.372a.764.764 0 00-.976-1.168L15.09 21.965a7.642 7.642 0 01-6.664.952l-6.868-2.231a1.529 1.529 0 01-.14-2.855z"
      clipRule="evenodd"
    ></path>
  </svg>
);

export default Telegram;
